import { createContext } from 'react'
import { ProgressBar } from './createProgressBar'

export const ProgressBarContext = createContext<ProgressBar>({
  addLoadingState: () => {},
  removeLoadingState: () => {},
  loadingStatesCount: 0,
  listen: () => () => {}
})
